module.exports = __webpack_public_path__ + "static/media/BM_Reports.df29a369.svg";